import { render, staticRenderFns } from "./IframeComponent.vue?vue&type=template&id=c582f9ba"
import script from "./IframeComponent.vue?vue&type=script&lang=ts"
export * from "./IframeComponent.vue?vue&type=script&lang=ts"
import style0 from "./IframeComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConsentBlocker: require('/app/components/base/ConsentBlocker/ConsentBlocker.vue').default})
